import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "selectionoptions"
    }}>{`SelectionOptions`}</h1>
    <p>{`Options for selection status in relation to previously selected objects.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ADD_TO`}</strong>{` = 1633969202`}</p>
      <p parentName="blockquote">{`Adds the object to the existing selection; if no object was previously selected, makes the object the only selected object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`REMOVE_FROM`}</strong>{` = 1919249734`}</p>
      <p parentName="blockquote">{`Deselects the object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`REPLACE_WITH`}</strong>{` = 1919250519`}</p>
      <p parentName="blockquote">{`Selects the object and deselects any previously selected objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SET_KEY`}</strong>{` = 1936028779`}</p>
      <p parentName="blockquote">{`Sets the key object. At least 2 objects must be selected, and the key object specified must be one of them.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      